import styled from 'styled-components';
import { KeyboardArrowDown, Clear, Search } from '@material-ui/icons';

export const SelectInput = styled.input`
    border: 1px solid #bcbcbc;
    border-radius: 4px;
    padding: 8px;
    padding-right: 30px;
    transition: border-color 150ms ease;
    outline: 0;
    width: calc(100% - 30px);

    ${({ isOpen }) =>
        isOpen
            ? `
    border-bottom: 1px solid #fff !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    cursor: text;
`
            : ''};

    ${({ disabled, isOpen }) =>
        !disabled && !isOpen
            ? `
    cursor: pointer;
    &:hover {
        border-color: #5195fd;
    }
    &:focus {
        border-color: #5195fd;
    }
`
            : ''};
`;

// `&&` doubles the styled-components class so these rules beat `@material-ui/core` SvgIcon JSS
// (`.MuiSvgIcon-root-*`), which is appended after our StyleSheetManager insertion point.
const inputIcon = (component) => styled(component)`
    && {
        position: absolute;
        right: 5px;
        top: 1px;
        color: #4d4d4d;
        width: 20px;
        height: 20px;
        font-size: 20px;
        display: inline-block;
        flex-shrink: 0;
        fill: currentColor;
    }

    ${({ disabled }) =>
        !disabled
            ? `
    && {
        cursor: pointer;
    }
`
            : ''};
`;

export const DownArrow = inputIcon(KeyboardArrowDown);
export const ClearIcon = inputIcon(Clear);
export const SearchIcon = inputIcon(Search);
//For fading out effect...
/**(Applied to DownArrow)
 * background-image: linear-gradient(to right, #ffffff00, white);
    padding-left: 40px;
 */
